import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_PRESCRIPTION_ADD_API,
  RQ_PRESCRIPTION_DELETE_API,
  RQ_PRESCRIPTION_LOOKUP_API,
  RQ_PRESCRIPTION_LOOKUP_ID_API,
  RQ_PRESCRIPTION_LOOKUP_PATIENT_API,
  RQ_PRESCRIPTION_UPDATE_API,
} from './Constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

//  Add Prescription
export const RQPrescriptionAddAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_prescription'],
    mutationFn: async ({formData, token}) => {
      if (!formData) {
        throw new Error('formData is undefined');
      }

      return rqCreateRequest(
        RQ_PRESCRIPTION_ADD_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//  Update Prescription
export const RQPrescriptionUpdateAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_update_prescription'],
    mutationFn: async ({id, formData, token}) => {
      return rqCreateRequest(
        withUrl(RQ_PRESCRIPTION_UPDATE_API, 'id', id),
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//  Lookup All Prescriptions
export const RQPrescriptionLookupAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_prescriptions'],
    queryFn: () =>
      rqCreateRequest(
        RQ_PRESCRIPTION_LOOKUP_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

//  Lookup Prescription By Id
export const RQPrescriptionLookupByIdAPI = (
  id,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_prescription', id],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_PRESCRIPTION_LOOKUP_ID_API, 'id', id),
        null,
        token,
        null,
      ),
    enabled: !!id && !!token,
    ...options,
  });

//  Lookup Prescriptions By Patient
export const RQPrescriptionLookupByPatientAPI = (
  patientId,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_prescription_patient', patientId],
    queryFn: () =>
      rqCreateRequest(
        withUrl(
          RQ_PRESCRIPTION_LOOKUP_PATIENT_API,
          'patientId',
          patientId,
        ),
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!patientId && !!token,
    ...options,
  });

//  Delete Prescription
export const RQDeletePrescriptionAPI = (callbacks = {}) =>
  useMutation({
    mutationKey: ['rq_delete_prescription'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(RQ_PRESCRIPTION_DELETE_API, 'id', id),
        null,
        token,
        null,
      ),
    ...callbacks,
  });
